import type { SVGProps } from 'react'

export function TwemojiFlagPoland(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 36 36" {...props}>
      {/* Icon from Twitter Emoji by Twitter - https://creativecommons.org/licenses/by/4.0/ */}
      <path fill="#EEE" d="M32 5H4a4 4 0 0 0-4 4v9h36V9a4 4 0 0 0-4-4" />
      <path fill="#DC143C" d="M0 27a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4v-9H0z" />
    </svg>
  )
}
